import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map, catchError, of } from 'rxjs';
import { UserService } from './user.service';

@Injectable()
export class AuthGuard implements CanActivate {

  
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(): Observable<boolean> | boolean {
    const token = localStorage.getItem('authToken');
    const currentUserStr = localStorage.getItem('Agroinformer-Current-User');

    // Basic checks
    if (!token || !currentUserStr) {
      this.clearStorageAndRedirect();
      return false;
    }

    try {
      const currentUser = JSON.parse(currentUserStr);
      const username = currentUser.username;

      // Check if we need to verify user status with server
      if (this.userService.shouldCheckUserStatus()) {
        return this.userService.checkUserStatus(username).pipe(
          map(isActive => {
            this.userService.updateLastCheckTime(); // Update check time
            
            if (!isActive) {
              this.clearStorageAndRedirect();
              return false;
            }
            return true;
          }),
          catchError(error => {
            console.error('Error checking user status:', error);
            // On error, allow access but don't update last check time
            // so it will retry next time
            return of(true);
          })
        );
      } else {
        // Use cached local check (check aktivan property)
        const isActive = currentUser.aktivan === 1;
        if (!isActive) {
          this.clearStorageAndRedirect();
          return false;
        }
        return true;
      }

    } catch (error) {
      console.error('Error in auth guard:', error);
      this.clearStorageAndRedirect();
      return false;
    }
  }

  private clearStorageAndRedirect(): void {
    localStorage.removeItem('authToken');
    localStorage.removeItem('Agroinformer-Current-User');
    localStorage.removeItem('last_user_status_check');
    this.router.navigate(['/home']);
  }
}